import { gettext } from '@eventbrite/i18n';
export const MOCK_ORGANIZER = '123';

export const mockedGetRatingSample = {
    rating: 2.9,
    total_count: {
        value: 1456,
        display: '1.45K',
    },
    break_down: [
        {
            rating_star: 5,
            count: 100,
            display: '100',
            percentage: 0.07,
        },
        {
            rating_star: 4,
            count: 300,
            display: '300',
            percentage: 0.21,
        },
        {
            rating_star: 3,
            count: 700,
            display: '700',
            percentage: 0.48,
        },
        {
            rating_star: 2,
            count: 0,
            display: '0',
            percentage: 0,
        },
        {
            rating_star: 1,
            count: 356,
            display: '356',
            percentage: 0.24,
        },
    ],
    tag_summary: [
        {
            id: '1',
            display_text: 'Meet people',
            count: 20,
        },
        {
            id: '12',
            display_text: 'Professionals',
            count: 7,
        },
    ],
};

export const GET_RATING_URL = '/api/v3/reviews/organizer_rating/';
export const ERROR_OTHER = gettext('There is an error. Try again later.');
export const SUPPORT_BASE_URL = 'https://www.eventbrite.com/support';
export const HELP_CENTER_ATTENDEE_URL = `${SUPPORT_BASE_URL}/articleredirect?anum=41782`;
export const HELP_CENTER_ORGANIZER_URL = `${SUPPORT_BASE_URL}/articleredirect?anum=41786`;
